import React, { memo, useEffect } from "react";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";
import { fetchPhones, fetchUserWallet, changeFormField } from "ducks/actions";
import {
  makeSelectFilteredPhones,
  makeSelectPhones,
  makeSelectPhonesForm,
  makeSelectPhoneVariant,
  makeSelectPhonePaymentOption,
  makeSelectIsFetchingData
} from "ducks/selectors";
import isEmpty from "lodash/isEmpty";
import { forms } from "utils/constants";
import { gotoUrl, urlParam } from "utils/helpers";
import SmartRender from "containers/SmartRender";
import Spinner, { styles } from "components/Spinner";
import { clearData } from "ducks/actions/index";

const PhonesHOC = Component =>
  function Comp(props) {
    const {
      phones,
      fetchPhones,
      fetchUserWallet,
      resetPhoneSelection,
      clearCustomerWallet,
      isFetchingPhones
    } = props;
    const resetPhone = urlParam("reset_phone");
    const userToken = urlParam("user_token");
    const customerId = urlParam("customer_id");
    // disable separate api call for wallet
    const useWallet = false; // urlParam("source") === "unlimited-xp";
    useEffect(
      () => {
        if (resetPhone) {
          resetPhoneSelection();
          clearCustomerWallet();
          gotoUrl(window.location.pathname, true, {
            reset: null,
            reset_phone: null
          });
        }
        if (isEmpty(phones) && !isFetchingPhones) {
          fetchPhones();
        }
        if (useWallet && (userToken || customerId)) {
          fetchUserWallet({
            user_token: userToken,
            customer_id: customerId
          });
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
    );
    return isEmpty(phones) ? (
      <Spinner sx={styles.fullPage} />
    ) : (
      <Component {...props} />
    );
  };

const mapStateToProps = createStructuredSelector({
  filteredPhones: makeSelectFilteredPhones(),
  phones: makeSelectPhones(),
  isFetchingPhones: makeSelectIsFetchingData("phones"),
  formData: makeSelectPhonesForm(),
  phoneVariant: makeSelectPhoneVariant(),
  phonePaymentOption: makeSelectPhonePaymentOption()
});

export function mapDispatchToProps(dispatch) {
  return {
    fetchPhones: () => {
      dispatch(fetchPhones());
    },
    fetchUserWallet: ({ user_token, customer_id }) => {
      dispatch(fetchUserWallet({ user_token, customer_id }));
    },
    clearCustomerWallet: () => {
      dispatch(clearData("customerInfo.data.wallet"));
    },
    resetPhoneSelection: () => {
      const phoneAttributes = [
        "paymentTerm",
        "phonePaymentCheckbox",
        "phoneColorCode",
        "phoneColorName",
        "phoneCapacity",
        "phoneVariant",
        "phonePaymentOption",
        "checkBoxValue"
      ];
      phoneAttributes.forEach(attribute => {
        dispatch(
          changeFormField({
            form: forms.PHONES_FORM,
            field: attribute,
            value: null
          })
        );
      });
    },
    change: (field, value) => {
      dispatch(
        changeFormField({
          form: forms.PHONES_FORM,
          field: field,
          value: value
        })
      );
    }
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(
  withConnect,
  reduxForm({
    form: forms.PHONES_FORM,
    destroyOnUnmount: false
  }),
  memo
)(PhonesHOC(SmartRender));
